export default __webpack_public_path__ + "static/media/royalty.621bda6c.JPG";